import { QuestionBase } from './base.question.class'

export class BodySelectorQuestion extends QuestionBase<string> {
  controlType = 'bodySelector'
}
